import React from "react";
import { loadModules } from "esri-loader";
import { withStyles } from "@material-ui/core/styles";
import MapIcon from "@material-ui/icons/Map";
import HomeIcon from "@material-ui/icons/Home";
import "./Map3.css";

//Estilos del componente
const useStyles = {
  webmap: {
    height: "calc(100vh)", //"calc(100vh - 116px)",
    width: "100%",
  },
};

let basemap = null;
let home = null;

//Componente para renderear el mapa
class Map3 extends React.Component {
  constructor(props) {
    super(props);
    this.mapRef = React.createRef();
    this.homeRef = React.createRef();
    this.searchRef = React.createRef();
    this.overviewDivRef = React.createRef();
    this.extentDivRef = React.createRef();
    this.basemapRef = React.createRef();
    this.legendDivRef = React.createRef();

    this.state = {
      map: null,
      measurementWidget: null,
      coordsWidget: null,
      sketchLayer: null,
      legendWidget: null,
      isRemovedLegendWidget: true,
      isOpenBaseMap: false,
      isOpenLgend: false,
    };
  }

  //Carga los scripts de argis, configura los widgets.
  componentDidMount() {
    loadModules(
      [
        "esri/map",
        "esri/dijit/BasemapGallery",
        "esri/dijit/Search",
        "esri/dijit/HomeButton",
        "esri/config",
        "esri/dijit/Legend",
      ],
      {
        version: "3.36",
        css: true,
        dojoConfig: {
          locale: "es",
        },
      }
    ).then(([Map, BasemapGallery, Search, HomeButton, esriConfig, Legend]) => {
      var center = [-99.1349, 19.2947];

      var map = new Map(this.mapRef.current, {
        center: center,
        zoom: 11,
        basemap: "osm",
        slider: true,
        autoResize: true,
        showLabels: true,
      });

      if (basemap !== null) {
        basemap.destroy();
      }
      basemap = new BasemapGallery(
        {
          showArcGISBasemaps: true,
          map: map,
        },
        this.basemapRef.current
      );
      basemap.startup();

      basemap.on("error", function (msg) {});
      basemap.on("load", function () {
        basemap.select(basemap.basemaps[0].id);
      });

      if (home !== null) {
        home.destroy();
      }

      home = new HomeButton(
        {
          map: map,
        },
        this.homeRef.current
      );
      home.startup();

      var search = new Search(
        {
          map: map,
        },
        this.searchRef.current
      );
      search.startup();

      this.setState({ map: map });

      if (this.props.onLoadedMap)
        this.props.onLoadedMap(map, this.legendDivRef);
    });
  }

  //Elimina la vista del mapa
  componentWillUnmount() {
    if (this.view) {
      this.view.container = null;
    }
  }

  //Renderea el mapa y los widgets
  render() {
    const { classes } = this.props;
    return (
      <div>
        <div className={classes.webmap} ref={this.mapRef} />
        <div id="search" ref={this.searchRef}></div>
        <div
          id="iconBasemap"
          onClick={() => {
            this.setState({ isOpenBaseMap: !this.state.isOpenBaseMap });
          }}
        >
          <MapIcon style={{ color: "white" }}></MapIcon>
        </div>
        <div
          id="basemapContainer"
          className={this.state.isOpenBaseMap ? "active" : null}
        >
          <div id="basemap" ref={this.basemapRef}></div>
        </div>

        <div id="homeButton" ref={this.homeRef} className="HomeButton">
          <HomeIcon style={{ color: "white" }}></HomeIcon>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(Map3);
